import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { environment } from './../../../environments/environment';
import { OtpResult } from '../../model/user-management-user.model';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {
  isLoginError : boolean = false;
  isOtpSent: boolean = false;
  otpResult: OtpResult  = null;
  isProd: any = environment.production;
  baseUrl: any = environment.baseUrl;

  constructor(public route: ActivatedRoute, private userService : UserService,private router : Router) { }

  ngOnInit() {
    if (this.isProd) {
      if (window.location.href.toLowerCase().startsWith('http://')) {
        //window.location.href = window.location.href.replace('http://', 'https://');;
      }
    }
    let m = this.route.snapshot.queryParamMap.get('m');
  }

  public sendOTP(userName){
      this.isOtpSent=false;
      this.otpResult = null;
      this.userService.getUserOTP(userName).subscribe((data : OtpResult)=>{
        if (data)
        {
            this.isOtpSent = data.Success; 
            this.otpResult = data;
        }
      },
      (err : HttpErrorResponse)=>{
        this.isOtpSent = false;
        this.isLoginError = true;
      });
  }
  

  public login(userName,password,otpCode){
     this.userService.userAuthentication(userName, password, otpCode).subscribe((data : any)=>{
      localStorage.setItem('userToken',data.access_token);
      //this.router.navigate(['main-page']);
      //this.router.navigateByUrl('/main-page');

      //let q = window.location.search;
      let lp = this.route.snapshot.queryParamMap.get('lp');
      if (lp) {
        window.location.href = "/lpi?lpi=" + encodeURIComponent(lp);
      } else {
          window.location.href = "/main-page";
      }
      
    },
    (err : HttpErrorResponse)=>{ 
      this.isLoginError = true;
    });
  }

  startOver() {
    window.location.href = "/";
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/user/sign-in/sign-in.component.ts